if (!customElements.get('pk-pdp-sticky')) {
  customElements.define('pk-pdp-sticky', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.root = document.getElementById(this.dataset.sectionId);
      if (!this.root) return;
      this.button = this.querySelector('[data-pk-sticky-add]');
      this.size = this.querySelector('[data-pk-size]');
      this.error = this.querySelector('[role=status]');
      this.button.addEventListener('click', () => {
        const original = this.root.querySelector('product-form [name=add]');
        if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
      });
      this.size.addEventListener('click', event => {
        event.preventDefault();
        const target = this.root.querySelector('variant-picker') || document.getElementById(this.dataset.formId);
        if (!target) return;
        target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const trigger = target.querySelector('[data-drawer-trigger]');
        const control = trigger || target.querySelector('select,button,input:not([type=hidden]):not(:disabled)');
        if (control) control.focus({ preventScroll: true });
        if (trigger) trigger.click();
      });
      this.sync = () => {
        const original = this.root.querySelector('product-form [name=add]');
        const form = document.getElementById(this.dataset.formId);
        if (!original || !form) { this.hidden = true; return; }
        this.hidden = false;
        this.button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
        this.button.textContent = original.classList.contains('is-loading') ? 'Ekleniyor…' : original.textContent.trim();
        const picker = this.root.querySelector('variant-picker');
        const selected = picker && picker.querySelector('input:checked,select option:checked');
        this.size.textContent = selected ? `Numara: ${selected.value} · Değiştir` : 'Numaranı seç';
        const message = this.root.querySelector('.js-form-error');
        this.error.textContent = message && !message.hidden ? message.textContent : '';
        this.error.hidden = !this.error.textContent;
      };
      // Escape animated product wrappers so fixed positioning is viewport-relative.
      document.body.appendChild(this);
      document.body.classList.add('pk-has-pdp-sticky');
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, characterData: true });
      this.root.addEventListener('change', this.sync);
      this.sync();
      this.unload = event => {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.observer.disconnect();
        this.root.removeEventListener('change', this.sync);
        document.removeEventListener('shopify:section:unload', this.unload);
        this.remove();
        document.body.classList.remove('pk-has-pdp-sticky');
      };
      document.addEventListener('shopify:section:unload', this.unload);
    }
  });
}
function pkInitPdpSliders(scope = document) {
  scope.querySelectorAll('.pk-pdp-recommendations').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.pk-pdp-slider');
    if (!track.children.length) { section.hidden = true; return; }
    section.querySelector('.pk-pdp-slider-controls').hidden = false;
    section.querySelectorAll('[data-pk-slide]').forEach(button => button.addEventListener('click', () => {
      track.scrollBy({ left: Number(button.dataset.pkSlide) * track.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
  });
}
pkInitPdpSliders();
document.addEventListener('shopify:section:load', event => pkInitPdpSliders(event.target));

/* --- Kardeş renge geçerken seçili numarayı taşı (2026-10-09) --- */
function pkCurrentSize() {
  const checked = document.querySelector('input.js-option:checked');
  return checked && !checked.classList.contains('is-unavailable') ? checked.value.trim() : '';
}
function pkSizeInput(value) {
  return [...document.querySelectorAll('input.js-option')].find(input => input.value.trim() === String(value));
}
function pkAvailableSizes() {
  return [...document.querySelectorAll('input.js-option')]
    .filter(input => !input.classList.contains('is-unavailable'))
    .map(input => input.value.trim());
}
function pkSizeNotice(text) {
  let notice = document.querySelector('[data-pk-size-notice]');
  if (!notice) {
    const holder = document.querySelector('.pk-size-drawer') || document.querySelector('variant-picker');
    if (!holder || !holder.parentNode) return;
    notice = document.createElement('p');
    notice.className = 'pk-size-carry-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('data-pk-size-notice', '');
    holder.parentNode.insertBefore(notice, holder);
  }
  notice.textContent = text;
}
function pkCarrySizeIntoColorLinks() {
  if (window.pkColorCarryReady) return;
  window.pkColorCarryReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-pk-color-link]');
    if (!link) return;
    const size = pkCurrentSize();
    if (!size) return;
    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('pk_size', size);
      link.setAttribute('href', url.toString());
    } catch (error) { /* keep the plain product URL */ }
  }, true);
}
function pkSyncDrawer() {
  const drawer = document.querySelector('pk-size-drawer');
  if (drawer && typeof drawer.syncValue === 'function') drawer.syncValue();
}
function pkApplyCarriedSize() {
  const wanted = new URLSearchParams(window.location.search).get('pk_size');
  if (!wanted) return;
  const input = pkSizeInput(wanted);
  if (input && !input.classList.contains('is-unavailable')) {
    if (!input.checked) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (label) label.click();
    }
    pkSyncDrawer();
    window.setTimeout(() => {
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pkSyncDrawer();
    }, 400);
    return;
  }
  const sizes = pkAvailableSizes();
  pkSizeNotice(sizes.length
    ? 'Bu renkte ' + wanted + ' numara yok. Seçilebilir numaralar: ' + sizes.join(', ') + '. Sipariş öncesi numaranızı seçin.'
    : 'Bu renkte seçilebilir numara bulunmuyor.');
}
pkCarrySizeIntoColorLinks();
pkApplyCarriedSize();
document.addEventListener('shopify:section:load', () => { pkCarrySizeIntoColorLinks(); pkApplyCarriedSize(); });
